import { render, staticRenderFns } from "./ModalAssign.vue?vue&type=template&id=dbb1af10"
import script from "./ModalAssign.vue?vue&type=script&lang=js"
export * from "./ModalAssign.vue?vue&type=script&lang=js"
import style0 from "./ModalAssign.vue?vue&type=style&index=0&id=dbb1af10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports